import { ArrowUp, Phone, Mail } from "lucide-react";
import { scrollToSection } from "@/components/Header";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#111111] text-[#F2F2F0] border-t border-white/15">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-10 flex flex-col md:flex-row items-center justify-between gap-6">
        <img
          src="/assets/logo-light.png"
          alt="One Piece Maintenance — For all your Plumbing needs"
          data-testid="footer-logo-image"
          className="h-16 w-auto"
        />
        <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-6">
          <a
            href="tel:+61452028256"
            data-testid="footer-phone-link"
            className="flex items-center gap-2 text-sm font-bold hover:text-[#6C8CFF] transition-colors duration-300"
          >
            <Phone className="w-4 h-4 text-[#6C8CFF]" /> 0452 028 256
          </a>
          <a
            href="mailto:onepiecemaintenance@gmail.com"
            data-testid="footer-email-link"
            className="flex items-center gap-2 text-sm font-bold hover:text-[#6C8CFF] transition-colors duration-300"
          >
            <Mail className="w-4 h-4 text-[#6C8CFF]" /> onepiecemaintenance@gmail.com
          </a>
          <p className="text-xs text-white/40 font-medium tracking-wide" data-testid="footer-copy">
            © {new Date().getFullYear()} One Piece Maintenance. All rights reserved.
          </p>
          <p className="text-xs text-white/40 font-medium tracking-wide" data-testid="footer-abn">
            ABN 65 255 707 375
          </p>
        </div>
        <button
          data-testid="back-to-top-button"
          onClick={() => window.__lenis?.scrollTo(0, { duration: 1.4 })}
          className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-white/60 hover:text-white transition-colors duration-300 group"
        >
          Back to top
          <ArrowUp className="w-4 h-4 transition-transform duration-300 group-hover:-translate-y-1" />
        </button>
      </div>
    </footer>
  );
}
